import { Brain, Gamepad2, Sparkles, Lock, Zap, GitCompare, Layers, Target, HelpCircle, Users, Trophy, Gem, Flag, Flame, Gift } from "lucide-react";

export const GAME_ICONS = { Brain, Gamepad2, Sparkles, Lock, Zap, GitCompare, Layers, Target, HelpCircle, Users, Trophy, Gem, Flag, Flame, Gift };

export const getIcon = (name) => GAME_ICONS[name] || Gamepad2;

// terminology helper
export const term = (event, key, fallback) => (event?.terminology?.[key]) || fallback;

export const EVENT_TYPE_EMOJI = {
  Corporate: "🏢", School: "🎓", College: "🎓", Birthday: "🎂", Wedding: "💍",
  Family: "🎉", Conference: "🎤", Exhibition: "🛍", Festival: "🎪", Competition: "🏆", Other: "✨",
};

export const gameGradient = (type) => {
  const map = {
    quiz: "from-[#FF3B30] to-[#FF2D55]", pixel_quest: "from-[#34C759] to-[#00A86B]",
    fortune_spin: "from-[#FFCC00] to-[#FF9500]", mystery_vault: "from-[#5856D6] to-[#007AFF]",
    rapid_fire: "from-[#FF9500] to-[#FF3B30]", match_master: "from-[#007AFF] to-[#5AC8FA]",
    memory_challenge: "from-[#AF52DE] to-[#FF2D55]", target_master: "from-[#FF2D55] to-[#FF3B30]",
    who_am_i: "from-[#5AC8FA] to-[#007AFF]", team_battle: "from-[#34C759] to-[#FFCC00]",
  };
  return map[type] || "from-[#FF3B30] to-[#FF2D55]";
};
